// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"fullscreen-exit-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 9H9V5M19 9H15V5M19 15H15V19M5 15H9V19","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FullscreenExit1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'fullscreen-exit-1',
    ref,
    icon: element,
  },
));

FullscreenExit1Icon.displayName = 'FullscreenExit1Icon';

export default FullscreenExit1Icon;
